<template>
  <FormPanel
      headline="Create Article Label"
      :errors="errors"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentArticleLabels/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/content-article-labels', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The content article label was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/article-labels')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
